/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 分页查看我的电子钱包明细
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetEWalletDetailParams {
  constructor(public pageNum: number, public pageSize: number) {}
}

export default async function (
  params: GetEWalletDetailParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.Page<member.EWalletDetailDTO>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/wallet/detail`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
